<app-icon-view
  (fileDropped)="onFileDropped($event)"
  (iconViewItemClicked)="onIconViewItemClicked($event)"
  (selectedItemEvent)="onSelectedItemEvent($event)"
  (parentChanged)="onParentChanged($event)"
  *ngIf="hasDndEnable"
  [fileExtensionTypes]="fileExtensionTypes"
  [foldersSelectable]="foldersSelectable"
  [hideFiles]="hideFiles"
  [hideFolders]="hideFolders"
  [invalidateSubject]="invalidateSubject"
  [isClientDrive]="isClientDrive"
  [isDialogView]="isDialogView"
  [navigateInvalidateSubject]="invalidateSubject"
  [parentId]="parentId"
  [queryName]="queryName"
  [selectOnlyCurrentDirectoryFiles]="selectOnlyCurrentDirectoryFiles"
  [selectedList]="selectedItems"
  [showHiddenItems]="showHiddenItems"
  [showSelectedItem]='showSelectedItem'
  [tags]="tags"
  [isThumbnailView]="isThumbnailView"
  appDnd
  hasDragAndDrop="true"
>
</app-icon-view>
<app-icon-view
  (iconViewItemClicked)="onIconViewItemClicked($event)"
  (selectedItemEvent)="onSelectedItemEvent($event)"
  *ngIf="!hasDndEnable"
  [hideFiles]="hideFiles"
  [hideFolders]="hideFolders"
  [invalidateSubject]="invalidateSubject"
  [isClientDrive]="isClientDrive"
  [parentId]="parentId"
  [queryName]="queryName"
  [showHiddenItems]="showHiddenItems"
  [tags]="tags"
  [isThumbnailView]="isThumbnailView"
>
</app-icon-view>
<ng-template #uploadToastRef>
  <div class="file-upload-toast">
    <div class="file-upload-toast__header pointer flex flex-row justify-start items-center">
      <div class="file-upload-toast__header__title">
        <h3 matTooltip="{{uploadMessage}}">{{uploadMessage}}</h3>
      </div>
      <div class="file-upload-toast__header__cancel">
        <button (click)="hideContent = !hideContent" class="btn" matTooltip="Hide Content">
          <i [ngClass]="{'fa-chevron-down':!hideContent, 'fa-chevron-up': hideContent}"
             class="far flex flex-row justify-center items-center"></i>
        </button>
        <button (click)="hideSnackbar()" class="btn" matTooltip="Close Dialog">
          <i class="far fa-times"></i>
        </button>
      </div>
    </div>
    <div *ngIf="!hideContent" class="file-upload-toast__content" fusePerfectScrollbar>
      <div *ngFor="let file of files; let i = index">
        <div class="file-upload-toast__content__header flex flex-row justify-start items-center">
          <div class="body p-tb-10 flex flex-row justify-start items-center full-grow-no-shrink-no-basis " >
            <div class="file-name full-grow-no-shrink-no-basis "  matTooltip="{{ file?.name }}">{{ file?.name }}</div>
            <p>{{ file?.formatedSize }}</p>
          </div>
          <ul class="grid-mini-button-container m-l-10">
            <li>
              <button (click)="openFile(i)" *ngIf="file?.progress === 100" class="grid-mini-button" mat-button
                      matTooltip="Open File">
                <i class="far fa-folder-open"></i>
              </button>
            </li>
            <li>
              <button (click)="retryUpload(i)" *ngIf="file?.cancelled" class="grid-mini-button" mat-button
                      matTooltip="Retry">
                <i class="far fa-undo"></i>
              </button>
            </li>

            <li>
              <button (click)="cancelUpload(i)" *ngIf="file?.progress < 100 && !file?.cancelled"
                      class="grid-mini-button"
                      mat-button
                      matTooltip="Cancel Upload">
                <i class="far fa-times"></i>
              </button>
            </li>
          </ul>
        </div>
        <div class="file-upload-toast__content__progress m-lr-10">
          <mat-progress-bar [value]="file?.progress" mode="determinate"></mat-progress-bar>
          <p *ngIf="file.errorMessage" class="error-message" matTooltip="{{ file.errorMessage }}"
             nameShortFormat>{{ file.errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
